<template>
  <div class="join-us-view">
    <div class="banner-box">
      <img src="@/assets/join-us.png" class="W100" />
    </div>

    <div class="background-white">
      <div class="outerBox">
        <div id="java-expert" class="anchor"></div>
        <div class="anchorBox">
          <!-- <a-anchor>
            <a-anchor-link href="#java-expert"><div>Java开发专家</div></a-anchor-link>
            <a-anchor-link href="#seniorJava" title="资深Java开发" />
            <a-anchor-link href="#front-end-expert" title="前端开发专家" />
            <a-anchor-link href="#business-development-experts" title="业务拓展专家" />
            <a-anchor-link href="#financial-products-operation" title="金融产品运营" />
            <a-anchor-link href="#product-intern" title="产品运营实习生" />
            <a-anchor-link href="#Java-intern" title="Java研发实习生" />
          </a-anchor> -->
          <a-anchor wrapperClass="PT80" :offsetTop="56">
            <a-anchor-link><div class="pointer" @click="scrolltoView('#java-expert')">Java开发专家</div></a-anchor-link>
            <a-anchor-link><div class="pointer" @click="scrolltoView('#seniorJava')">资深Java开发</div></a-anchor-link>
            <a-anchor-link><div class="pointer" @click="scrolltoView('#front-end-expert')">前端开发专家</div></a-anchor-link>
            <a-anchor-link><div class="pointer" @click="scrolltoView('#business-development-experts')">业务拓展专家</div></a-anchor-link>
            <a-anchor-link><div class="pointer" @click="scrolltoView('#financial-products-operation')">金融产品运营</div></a-anchor-link>
            <a-anchor-link><div class="pointer" @click="scrolltoView('#product-intern')">产品运营实习生</div></a-anchor-link>
            <a-anchor-link><div class="pointer" @click="scrolltoView('#Java-intern')">Java研发实习生</div></a-anchor-link>
          </a-anchor>
        </div>
        <div style="padding: 40px 0;">
          <div class="positionTitle"><img src="@/assets/iconImg.png" >Java开发专家</div>
          <div class="positionContent">
            <div class="">岗位职责</div>
            <p>1、负责业务的系统分析和架构设计，深入挖掘和分析业务需求，撰写技术方案和系统设计，确保系统的架构质量；</p>
            <p>2、技术细节的实现，推动技术架构在业务落地并解决业务发展遇到的架构问题，持续提升系统高可用性和稳定性；</p>
            <p>3、系统核心部分代码编写，疑难问题的解决；</p>
            <p>4、维护和升级现有软件产品和系统，快速定位并修复现有软件缺陷；</p>
            <p>5、针对新人、普通开发人员进行有效辅导，帮助其快速成长；</p>
            <p>6、能为团队引入创新的技术、创新的解决方案，用创新的思路解决问题，能对现存或未来系统进行宏观的思考，规划形成统一的框架、平台或组件的优先。</p>
            <div class="">岗位要求</div>
            <p>1、5年以上工作经验，有高并发，复杂系统设计和架构经验，并主导设计过所在公司重要系统，有一定团队管理能力；</p>
            <p>2、具备扎实的Java基础，精通JDK在集合、IO、并发、线程、反射、类体系等方面的运用，精通JVM调优；</p>
            <p>3、熟悉SOA，有平台化实施经验者，有大数据量、高并发系统和大型网站构建经验者优先；</p>
            <p>4、深刻理解软件研发流程，具备很强的技术领导力、沟通协调能力、商业敏感性；</p>
            <p>5、具有较好的沟通能力，思路清晰，善于思考，能独立分析和解决问题。</p>
            <div class="alignCenter"><a class="toMail" href="mailto:zhaopin@bigrule.com" target="_blank">投递简历</a></div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="outerBox">
        <div id="seniorJava" class="anchor"></div>
        <div style="padding: 40px 0;">
          <div class="positionTitle"><img src="@/assets/iconImg.png" >资深Java开发</div>
          <div class="positionContent">
            <div class="">岗位职责</div>
            <p>1、深入挖掘和分析业务需求，撰写技术方案和系统设计，确保系统的架构质量；</p>
            <p>2、系统核心部分代码编写，疑难问题的解决；</p>
            <p>3、维护和升级现有软件产品和系统，快速定位并修复现有软件缺陷； 熟悉Spring、iBatis等开源框架；</p>
            <p>4、针对新人、普通开发人员进行有效辅导，帮助其快速成长； 熟悉Spring、iBatis等开源框架；</p>
            <p>5、能为团队引入创新的技术、创新的解决方案，用创新的思路解决问题，能对现存或未来系统进行宏观的思考，规划形成统一的框架、平台或组件的优先。</p>
            <div class="">岗位要求</div>
            <p>1、本科或以上学历，计算机软件或相关专业；</p>
            <p>2、精通Web编程，Java基础扎实，有3年以上使用Java语言进行web开发的经验，熟悉html，javascript；</p>
            <p>3、熟悉面向对象设计开发，熟悉各种常用设计模式，对于你用过的开源框架，能了解到它的原理和机制； 熟悉Spring、iBatis等开源框架；</p>
            <p>4、熟悉基于Oracle或者Mysql的设计和开发、Linux操作系统；</p>
            <p>5、对技术有强烈的兴趣，喜欢钻研，具有良好的学习能力，沟通技能，团队合作能力；</p>
            <p>6、熟悉SOA，有平台化实施经验者，有大数据量、高并发系统和大型网站构建经验者优先；</p>
            <p>7、有公司法务，法院业务系统等相关业务系统开发经验者优先。</p>
            <div class="alignCenter"><a class="toMail" href="mailto:zhaopin@bigrule.com" target="_blank">投递简历</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-white">
      <div class="outerBox">
        <div id="front-end-expert" class="anchor"></div>
        <div style="padding: 40px 0;">
          <div class="positionTitle"><img src="@/assets/iconImg.png" >前端开发专家</div>
          <div class="positionContent">
            <div class="">岗位职责</div>
            <p>1、负责客户端系统的研发；</p>
            <p>2、参与客户端框架及应用组件的规划与设计；</p>
            <p>3、提升系统的整体用户体验和前端技术实力；</p>
            <p>4、进行基于html5及移动互联网技术的技术论证和发展规划。</p>
            <div class="">岗位要求</div>
            <p>1、至少5年前端开发的工作经验，有大型网站的前端架构部署和实践经验；</p>
            <p>2、精通至少一门非Web前端语言，对前后端合作模式有深入了解并有项目经验；</p>
            <p>3、善于沟通，有良好的文档写作能力，口头沟通能力，良好的团队合作精神，良好的抽象思维，理性地做出技术决策，具有风险控制意识；</p>
            <p>4、熟悉多种JavaScript框架及对它们适用的范围及优劣有独到见解。</p>
            <div class="alignCenter"><a class="toMail" href="mailto:zhaopin@bigrule.com" target="_blank">投递简历</a></div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="outerBox">
        <div id="business-development-experts" class="anchor"></div>
        <div style="padding: 40px 0;">
          <div class="positionTitle"><img src="@/assets/iconImg.png" >业务拓展专家</div>
          <div class="positionContent">
            <div class="">岗位职责</div>
            <p>1、独立负责政务领域的业务拓展和服务，深入理解用户诉求，传递价值和使命；</p>
            <p>2、结合司法、政务领域的业务解决方案，支持架构师将政务用户的业务和管理系统对接，实现互联网移动智能政务；</p>
            <p>3、发展和开拓内外部的合作伙伴，驱动各方快速达成一致目标，发展和维护在政务领域的产品、服务口碑；</p>
            <p>4、负责合作项目的落地工作，从项目前期规划到后期收尾完整的项目生命周期管理，用专业化的项目过程管理来保证项目目标的达成；</p>
            <p>5、对各种业务数据进行收集、整理、分析，从中发现机会和问题，不断精进和优化最终拿到结果。</p>
            <div class="">岗位要求</div>
            <p>1、本科学历以上，金融、法律或计算机专业，能力优秀可宽限；</p>
            <p>2、能独立负责区域内法律服务领域、金融机构等企业业务拓展和服务，理解用户诉求，传递价值和使命；</p>
            <p>3、发展和开拓内外部的合作伙伴，驱动各方快速达成一致目标；</p>
            <p>4、具有优秀的沟通表达能力、良好的应变能力，以及较强团队合作精神；</p>
            <p>5、善于分析和把握客户需求，能与客户建立良好关系；</p>
            <p>6、3年以上市场销售工作经验，有法院、银行、公安、企业法务工作经历和资源者优先；</p>
            <p>7、个性开朗，肯吃苦有冲劲，能胜任出差任务。</p>
            <div class="alignCenter"><a class="toMail" href="mailto:zhaopin@bigrule.com" target="_blank">投递简历</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-white">
      <div class="outerBox">
        <div id="financial-products-operation" class="anchor"></div>
        <div style="padding: 40px 0;">
          <div class="positionTitle"><img src="@/assets/iconImg.png" >法律产品运营</div>
          <div class="positionContent">
            <div class="">岗位职责</div>
            <p>1、主要负责对接法院、仲裁委、调解委员会；银行、保险、AMC、信用卡中心和大企业的法务部/资产管理部，通过科技产品赋能司法行业；</p>
            <p>2、挖掘客户和行业供应链的法律服务需求，推动整体解决方案在大客户的落地服务；</p>
            <p>3、针对大客户的共性和差异化需求，进行提炼分析，出具方案，推动商务、产品、技术、服务团队进行实施。</p>
            <div class="">岗位要求</div>
            <p>1、本科以上学历，2年以上相关工作经验；</p>
            <p>2、具有良好的法律行业知识，或者具有较强的产品运营基础；</p>
            <p>3、资源整合能力强，有较强的需求分析能力，以客户需求为中心，解决客户问题；</p>
            <p>4、有很强的沟通、协调、推进能力，创新学习和很好的抗压能力，能够有效的组织和推进外联合作；</p>
            <p>5、有过律师、调解员、书记员、公司法务、产品运营从业经验者优先；</p>
            <p>6、接受出差安排。</p>
            <div class="alignCenter"><a class="toMail" href="mailto:zhaopin@bigrule.com" target="_blank">投递简历</a></div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="outerBox">
        <div id="product-intern" class="anchor"></div>
        <div style="padding: 40px 0;">
          <div class="positionTitle"><img src="@/assets/iconImg.png" >产品运营实习生</div>
          <div class="positionContent">
            <div class="">岗位职责</div>
            <p>1、聆听客户声音，整理客户需求（包括不限于金融机构、司法机关等），汇总成标准的需求文档；</p>
            <p>2、将需求转化为基本的产品语言，与PD、开发对接，获得完整的方案；</p>
            <p>3、跟踪产品需求的排期、开发、上线情况；</p>
            <p>4、针对客户的实际情况，出具不同的产品/服务方案，并就方案进行沟通落地执行；</p>
            <p>5、协同内外部各项资源，准时完满得达成项目目标；</p>
            <p>6、完成其他由主管分配的工作。</p>
            <div class="">岗位要求</div>
            <p>1、专业：法学相关专业尤佳，其他专业依然欢迎（专业不是门槛）；</p>
            <p>2、兴趣：对司法行业，抱有热忱与好奇；</p>
            <p>3、心态：踏实肯干，吃苦耐劳；空杯心态，热爱学习；乐观向上，抗压能力强；</p>
            <p>4、能力：具有“客户第一”的服务意识，优秀的沟通能力，极强的学习能力，较为明确的职业规划，目标导向，落地执行能力强。</p>
            <div class="alignCenter"><a class="toMail" href="mailto:zhaopin@bigrule.com" target="_blank">投递简历</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-white">
      <div class="outerBox">
        <div id="Java-intern" class="anchor"></div>
        <div id="financial-products-operation" class="anchor"></div>
        <div style="padding: 40px 0;">
          <div class="positionTitle"><img src="@/assets/iconImg.png" >Java研发实习生</div>
          <div class="positionContent">
            <div class="">岗位要求</div>
            <p>1、计算机相关专业，或数学、机械等偏逻辑和动手能力的专业；</p>
            <p>2、热衷于互联网技术，热衷于解决富有挑战性的问题；</p>
            <p>3、熟练使用调试工具，熟悉Java语言；</p>
            <p>4、熟悉HTML语言；</p>
            <p>5、熟悉Python、shell等脚本语言</p>
            <p>6、了解常见数据结构与算法；</p>
            <p>7、有竞赛获奖者优先，有项目经验者优先，有社会活动经验善于沟通者优先；</p>
            <p>8、接受短期出差。</p>
            <div class="alignCenter"><a class="toMail" href="mailto:zhaopin@bigrule.com" target="_blank">投递简历</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollIntoView (el) {
      this.showJoinUs = false
      setTimeout(() => {
        document.querySelector(el).scrollIntoView()
      }, 200)
      // document.querySelector(el).scrollIntoView()
    },
    scrolltoView (el) {
      document.querySelector(el).scrollIntoView()
    }
  }
}
</script>

<style lang="less" scoped>
.join-us-view {
  .areaTitle{
    font-size: 32px;
    color: #000;
    font-weight: bold;
    padding-top: 178px;
    text-align: center;
    letter-spacing: 4px;
  }
  .moduleTitle{
    font-size: 32px;
    font-weight: bold;
    color: #fff;
    padding-top: 55px;
    text-align: center;
    letter-spacing: 4px;
  }
  .anchor{
    position: absolute;
    top: -70px;
  }
  .mediationPlatform{
    position: relative;
    background: url(~@/assets/mediation.gif) top center no-repeat;
    height: 673px;
  }
  .judicialConfirmation{
    position: relative;
    height: 673px;
  }
  .judicialConfirmation .floorPlan img{
    width: 144px;
    height: 100px;
  }
  .enterprisePlatform{
    position: relative;
    background: url(~@/assets/enterprisePlatform.gif) top center no-repeat;
    height: 677px;
  }
  .securitiesPlatform{
    position: relative;
    height: 650px;
  }
  // .coreTechnology{
  //   background: url(../assets/coreTechnology.gif) top center no-repeat;
  //   height: 673px;
  // }
  .banner-box{
    // background: url('../../assets/join-us.png?id=1') top center no-repeat;
    // height: 416px;
  }
  .customer{
    background: #fff;
  }
  .cooperationUnit{
    background: #fff;
  }
  .contactUs{
    background: #fff;
  }
  .contactUs img{
    max-width: 1000px;
    width: 100%;
  }
  .cooperationList{
    justify-content: center;
    padding: 20px 0 40px 0;
  }
  .outerBox{
    position: relative;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    font-size: 22px;
    letter-spacing: 2px;
  }
  .floatContent{
    position: absolute;
    top: 150px;
    left: 800px;
  }
  .point{
    display: inline-block;
    width: 24px;
    height: 25px;
    margin-right: 20px;
  }
  .point img{
    vertical-align: top;
  }
  .divMB{
    margin-bottom: 40px;
  }
  .number{
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 0;
    margin-right: 8px;
  }
  .copywriting{
    margin: 26px 0;
    font-size: 24px;
    color: #fff;
  }
  .copywriting img{
    margin-right: 10px;
  }
  .confirmContent{
    padding: 45px 0 20px 45px;
  }
  .confirmCopywriting{
    margin: 20px 0;
    font-size: 24px;
    color: #fff;
  }
  .confirmCopywriting img{
    margin-right: 10px;
  }
  .MT55{
    margin-top: 55px;
  }
  .MT90{
    margin-top: 90px;
  }
  .securities{
    padding: 5px 0 20px 45px;
  }
  .floorPlan{
    background: #fff;
    padding: 15px 10px 20px 10px;
    border-radius: 4px;
    font-size: 12px;
    letter-spacing: 0;
    margin: 20px 8px;
  }
  .floorPlan img{
    width: 163px;
    height: 110px;
    margin-bottom: 10px;
    background: #000
  }
  .enterpriseLogo{
    font-size: 12px;
    margin: 30px 8px;
    color: #fff;
  }
  .enterpriseLogo div{
    /* background: #fff;
    padding: 5px;
    border-radius: 500px; */
    margin-bottom: 10px;
  }
  .enterpriseLogo img{
    /* width: 80px; */
  }
  .securitiesContent{
    padding-left: 80px;
    font-size: 14px;
  }
  .securitiesContent div{
    padding: 2px 0;
  }
  .spanTitle{
    width: 85px;
    display: inline-block;
  }
  .securitiesImg{
    margin-top: 50px;
  }
  .approvalContent{
    font-size: 24px;
    text-align: center;
    margin: 20px 0;
    letter-spacing: 8px;
  }
  .tips{
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
  }
  .borderImg{
    border: 1px solid #e8e8e8;
  }
  .footer{
    background: #096dd9;
    padding: 35px 0;
    color: #fff;
    text-align: center;
  }
  .footer img{
    width: 150px;
    height: 150px;
    margin-right: 20px;
  }
  .footerBox{
    font-size: 18px;
    text-align: left;
  }
  .copyRight{
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #fff;
    font-size: 14px;
  }
  .copyRight span{
    margin-right: 20px;
  }
  .customerType{
    font-size: 22px;
    font-weight: bold;
    padding: 30px 0 15px 0;

  }
  .customerBox{
    width: 100%;
  }
  .customerList{
    padding: 8px 0;
  }
  .customerList img{
    margin-right: 8px;
  }
  .bisect div{
    margin-right: 45px;
  }
  .trisection div{
    width: 33.3%;
  }
  .fiveEqual div{
    width: 20%;
  }
  .fourEqual div{
    width: 22%;
  }
  .address{
    position: absolute;
    padding: 40px 30px;
    right: 0;
    z-index: 80;
    background: #fff;
    box-shadow: 0 0 10px 2px #ccc;
    letter-spacing: 0;
  }
  .addressBox{
    padding: 70px 0;
  }
  .address .title{
    text-align: center;
  }
  .address .subheading{
    font-size: 18px;
    margin: 40px 0 5px 0;
  }
  .address .details{
    font-size: 16px;
  }
  .address .details img{
    width: 25px;
    margin-right: 8px;
  }
  .jionUsCopywriting{
    position: absolute;
    top: 297px;
    right: 147px;
    color: #fff;
  }
  .jionUsCopywriting a{
    color: #fff;
    text-decoration: none;
  }
  .anchorBox{
    position: absolute;
    right: 10px;
    top: 0;
  }
  .background-white{
    background: #fff;
  }
  .positionTitle{
    display: inline-block;
    padding: 4px 10px;
    background: #1d4ae5;
    border-radius: 5px;
    color: #fff;
    font-size: 16px;
  }
  .positionTitle img{
    width: 25px;
    height: 25px;
  }
  .positionContent{
    padding: 20px 220px 20px 30px;
  }
  .positionContent div{
    font-size: 18px;
    margin: 30px 0 10px;
    font-weight: bold;
  }
  .positionContent p{
    font-size: 16px;
    line-height: 36px;
    margin-bottom: 0;
  }
  .toMail{
    border: 1px solid #1d4ae5;
    padding: 10px 20px;
    color: #1d4ae5;
    border-radius: 30px;
    text-decoration: none;
  }
  .alignCenter{
    text-align: center;
  }
  .pointer{
    cursor: pointer;
  }
  .pointer:hover{
    color: #096dd9;
  }
}
@media screen and (max-width: 520px) {
  .join-us-view {
    .positionContent {
      padding: 0 16px;
    }
    .anchorBox {
      display: none;
    }
    .positionTitle {
      margin-left: 16px;
    }
  }
}
</style>
